import React, {Fragment} from "react";
import {useSelector} from "react-redux";
import CommonHeader from "../../components/Headers/CommonHeader";
import AddUser from "../../components/Modal/AddUser";
import ChangeOwner from "../../components/Modal/ChangeOwner";
import ProtectedContent, {usePermissionCheck} from "../../components/protectedContent";
import SafeView from "../../components/safeView/SafeView";
import PageURLContextProvider from "../../contexts/pageURLContext";
import {useDisclosure} from "../../hooks/useDisclosure";
import {getUserProfile} from "../../redux/Selectors/users.selector";
import UsersTable from "./usersTable";

const UsersComponent = () => {
  const {
    isOpen: isAddUserOpen,
    onOpen: openAddUser,
    onClose: closeAddUser,
  } = useDisclosure();
  const {
    isOpen: isChangeOwnerOpen,
    onOpen: openChangeOwner,
    onClose: closeChangeOwner,
  } = useDisclosure();
  const canAddUser = usePermissionCheck(["add_user"]);
  const canChangeOrgOwner = usePermissionCheck(["change_organizationowner"]);
  const profile = useSelector(getUserProfile);

  return (
    <SafeView>
      <ProtectedContent perms={["view_user"]} showFallback>
        <Fragment>
          {isAddUserOpen && <AddUser onCancel={closeAddUser} open={isAddUserOpen} />}
          {isChangeOwnerOpen && (
            <ChangeOwner open={isChangeOwnerOpen} onClose={closeChangeOwner} />
          )}
          <ProtectedContent
            perms={["add_user", "change_organizationowner"]}
            shouldHaveAllPermissions={false}
          >
            <CommonHeader
              content={"Add User"}
              handleAddClick={openAddUser}
              testID={"add_user"}
              showFirstButton={canAddUser}
              showSecondButton={profile?.is_owner && canChangeOrgOwner}
              secondContent={"Change Organization Owner"}
              handleSecondClick={openChangeOwner}
              secondTestID={"change_org_owner"}
            />
          </ProtectedContent>
          <UsersTable />
        </Fragment>
      </ProtectedContent>
    </SafeView>
  );
};

const UsersPage = () => {
  return (
    <PageURLContextProvider>
      <UsersComponent />
    </PageURLContextProvider>
  );
};

export default UsersPage;
